/* eslint-disable react-hooks/exhaustive-deps */

// Libs
import React, { useCallback, useEffect } from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";

// Hooks
import { useZohoSubscriptions } from "hooks/zoho-integration-sdk";
import { useSDKAuth } from "hooks/auth-sdk";

// Components
import MainLoader from "components/libs/loader";
import MainLoading from "components/libs/loading";

function PaymentRedirectPage() {
  const location = useLocation();
  const { user } = useAuth0();

  //#region Get Params
  const planCode = new URLSearchParams(location.search).get("planCode");
  //#endregion

  //#region Zoho Integration
  const { onCreateSubscription } = useZohoSubscriptions({
    subscriptionId: "",
  });
  //#endregion

  //#region Auth Hook
  const { authorizationLogin, authorizationEvent, isAuth } = useSDKAuth();

  //? Redirect to Dashboard
  const redirectToCheckout = useCallback(
    async ({ planCode }) => {
      const defaultTenant = await authorizationEvent();
      const submission = {
        email: user?.email,
        planCode: planCode,
        tenantName: defaultTenant.tenantName,
        customerId: defaultTenant?.customerId,
      };
      onCreateSubscription(submission);
    },
    [authorizationEvent]
  );
  //#endregion

  //#region Handle Redirect to Default Tenant
  useEffect(() => {
    if (!isAuth) {
      localStorage.setItem("planCode", planCode);
      authorizationLogin();
    } else {
      const getPlanCode = localStorage.getItem("planCode");
      redirectToCheckout({ planCode: getPlanCode });
    }
  }, [authorizationLogin, isAuth, redirectToCheckout]);
  //#endregion

  return (
    <>
      <MainLoader />
    </>
  );
}

export default withAuthenticationRequired(PaymentRedirectPage, {
  onRedirecting: () => <MainLoading />,
  returnTo: "/",
});
